import { render, staticRenderFns } from "./ProductoTiendaTableComponent.vue?vue&type=template&id=fc798c3c&"
import script from "./ProductoTiendaTableComponent.vue?vue&type=script&lang=js&"
export * from "./ProductoTiendaTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports